
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g8b119mQqhZc2IdyxzLNHTlIGjf2CHqBV0l6i8NNHjzAMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexObyxeCOPuG_45gmEnnIyaMi8hQ8wiV_45qVVuGg039U4QBkMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchExeNlJArcVOnhS99XTq7kUqaw4_45k8HRzhaLVWFWQ2jIMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexsrNFBPNQ9XmiLFXZSKxXUaWk7Vds5LXSlRMcTtYghXoMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93K6ILTErVfY3XC8DZTv2nR81lrw9fvh4vxEA3SgCKu9oMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexmsFSOp3RAZZ39p13ut0N1XDnu487NOImRq5YCBDDE2YMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_932nh3XE7dCbwP1Fr0xvv3LVP7LNbiqHg5CkqNzkVCaDoMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexSmWU4Vza3EiGxHDxNAWnLVhspvfuqpGKfWH2vF4qKpkMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_936OpSylgWiKaV_Nvt_45_45fl7hQLMc1q30ANxZNVu1k_16UMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexvV0_NGIdMuIY5NVlI2a5haj1rqIFTsckvg1V0cxfPsAMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index0mJmoWJt8WtAaq8_GrSqEIBV3wFeTQHfWZgzBLOJndEMeta } from "/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexmsFSOp3RAZZ39p13ut0N1XDnu487NOImRq5YCBDDE2YMeta || {},
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexSmWU4Vza3EiGxHDxNAWnLVhspvfuqpGKfWH2vF4qKpkMeta || {},
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexvV0_NGIdMuIY5NVlI2a5haj1rqIFTsckvg1V0cxfPsAMeta || {},
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index0mJmoWJt8WtAaq8_GrSqEIBV3wFeTQHfWZgzBLOJndEMeta || {},
    component: () => import("/codebuild/output/src1251490969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]